module.exports = __webpack_public_path__ + "static/fibonacci-8ba114be51cc69e3fb89f77bc7966f1b.svg";